import { Box, Container, Link, List, ListItem, Typography } from '@mui/material';
import React from 'react';

const LowerFooter = () => {
    return (
        <Box sx={{ background:'#222222' }}>
            <Container>
        <Box sx={{ display:'flex',alignItems:{xs:'center',sm:'center'},justifyContent:{xs:'center',sm:'center',sm:'space-between'},flexDirection:{xs:'column',sm:'column',md:'row'},pt:{xs:2,sm:2,md:0} }}>
            <Typography sx={{ color:'white',verticalAlign:'middle',margin:'auto 0' }} variant='body2'>Copyright © 2022 <span style={{ color:'#C2A990'}}>Gecko</span> all rights reserved. Powered by The4</Typography>
        <Box>
            <List sx={{ display:'flex',flexDirection:'row',width:'auto',gap:0 }}>
            <ListItem sx={{ padding:1,width:'auto' }}><Link className='listItemLinkFooter' style={{color:'white',cursor:'pointer',fontSize:'15px', fontFamily:'lato, sans-serif',textDecoration:'none'}} to={""}>Shop</Link></ListItem>
            <ListItem sx={{ padding:1,width:'auto' }}><Link className='listItemLinkFooter' style={{color:'white',cursor:'pointer',fontSize:'15px', fontFamily:'lato, sans-serif',textDecoration:'none'}} to={""}>About Us</Link></ListItem>
            <ListItem sx={{ padding:1,width:'auto' }}><Link className='listItemLinkFooter' style={{color:'white',cursor:'pointer',fontSize:'15px', fontFamily:'lato, sans-serif',textDecoration:'none'}} to={""}>Contact</Link></ListItem>
            <ListItem sx={{ padding:1,width:'auto' }}><Link className='listItemLinkFooter' style={{color:'white',cursor:'pointer',fontSize:'15px', fontFamily:'lato, sans-serif',textDecoration:'none'}} to={""}>Blog</Link></ListItem>
            </List>
        </Box>
        </Box>
        </Container>
        </Box>
        
    );
}

export default LowerFooter;
